import { TripsOverviewMap, type OverviewPin } from "./TripsOverviewMap";

// Shared "is this the right spot?" confirmation — a single pin on a map plus
// confirm / back. Used anywhere the user picks a place we have coordinates
// for and should verify the geocoder before committing (Plan search, the
// trip BeachPicker). Renders content only; the caller supplies the wrapper
// (card / modal padding) so it fits each surface.

export function SpotConfirm({
  name,
  region,
  lat,
  lng,
  confirmLabel,
  backLabel = "Back",
  onConfirm,
  onBack,
}: {
  name: string;
  region?: string;
  lat: number;
  lng: number;
  confirmLabel: string;
  backLabel?: string;
  onConfirm: () => void;
  onBack: () => void;
}) {
  const pins: OverviewPin[] = [
    { lat, lng, color: "#0e7c86", tripName: "", beachName: name },
  ];
  return (
    <div>
      <p className="font-display text-base font-bold text-ink">
        Is this the right spot?
      </p>
      <p className="mt-0.5 truncate text-sm text-ink/60">
        {name}
        {region ? ` · ${region}` : ""}
      </p>
      <div className="mt-3">
        <TripsOverviewMap pins={pins} interactive={false} />
      </div>
      <div className="mt-3 flex gap-2">
        <button
          type="button"
          onClick={onConfirm}
          className="btn-primary flex-1"
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          onClick={onBack}
          className="inline-flex min-h-[44px] items-center justify-center rounded-full px-4 py-2 text-sm font-semibold text-ink/70 ring-1 ring-inset ring-ink/15 transition hover:bg-ink/5"
        >
          {backLabel}
        </button>
      </div>
    </div>
  );
}
